import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['selectedRecord']
  connect() {
  }

  render(event) {
    var element = this.selectedRecordTargets.filter(x => x.id === this.id)[0]
    const [_data, _status, xhr] = event.detail

    element.innerHTML = this.decodeHTMLEntities(xhr.response)
  }

  get id() {
    return event.currentTarget.dataset.id;
  }
  
  decodeHTMLEntities(response) { 
    var textArea = document.createElement('textarea'); 
    textArea.innerHTML = response; 
    return textArea.value; 
   } 
}
